import { render, staticRenderFns } from "./TabLinks.vue?vue&type=template&id=57a4d53b&scoped=true"
import script from "./TabLinks.vue?vue&type=script&lang=js"
export * from "./TabLinks.vue?vue&type=script&lang=js"
import style0 from "./TabLinks.vue?vue&type=style&index=0&id=57a4d53b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4d53b",
  null
  
)

export default component.exports